import { apiClient } from '@shared/api';
import type { ApiResponse } from '@shared/types';
import type { FirmOfferSummaryDto, FirmOfferDetailDto } from '../types/salesOrder.types';

// FO-SOI-3: NetSuite Firm Offer lookup. The backend filters to awarded FOs with
// positive balance (custbody_approvalstatus = 14, balance > 0).
class FirmOfferService {
  private readonly baseUrl = '/sales-orders/firm-offers';

  async search(
    query: string | null,
    customerId: string | null,
    take: number | undefined = 20,
    mine = false,
  ): Promise<FirmOfferSummaryDto[]> {
    const params: Record<string, string | number | boolean> = { take: take ?? 20 };
    if (query) params.q = query;
    if (customerId) params.customerId = customerId;
    // "My FOs" — server scopes to the signed-in user's NetSuite employee id.
    if (mine) params.mine = true;

    const { data } = await apiClient.get<ApiResponse<FirmOfferSummaryDto[]>>(this.baseUrl, { params });
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Failed to search firm offers');
  }

  async getById(foInternalId: string, signal?: AbortSignal): Promise<FirmOfferDetailDto> {
    const { data } = await apiClient.get<ApiResponse<FirmOfferDetailDto>>(
      `${this.baseUrl}/${foInternalId}`,
      { signal },
    );
    if (data.success && data.data) return data.data;
    throw new Error(data.message || 'Firm Offer not found or no longer eligible');
  }
}

export const firmOfferService = new FirmOfferService();
